module.exports = __webpack_public_path__ + "static/media/nima_walking_3b.fbc54290.gif";